import React, { ReactNode } from "react";
import { Box, DialogActions, Divider } from "@mui/material";

interface ProgressModalFooterProps {
  left?: ReactNode;
  right?: ReactNode;
}

const ProgressModalFooter: React.FC<ProgressModalFooterProps> = ({
  left,
  right,
}) => (
  <>
    <Divider sx={{ mx: 3 }} />
    <DialogActions
      sx={{ padding: "16px 24px 20px", justifyContent: "space-between" }}
    >
      <Box>{left}</Box>
      <Box>{right}</Box>
    </DialogActions>
  </>
);

export default ProgressModalFooter;
